import React, { Fragment, useState } from 'react';
import PropTypes from 'prop-types';

import ResumeClassroomDialogView from './ResumeClassroomDialog.view';

const ResumeClassroom = ({
  bookmarkProgress,
  onUpdateCurrentSubsection,
  onUpdateBookmarkProgress,
  onUpdateIsAutoPlayVideo,
  resumeClassroomDialogComponent: ResumeClassroomDialogComponent,
}) => {
  const { subSectionId, subSectionReferId } = bookmarkProgress;
  const [open, setOpen] = useState(typeof bookmarkProgress !== 'undefined');

  const handleOnResume = () => {
    onUpdateCurrentSubsection(subSectionId, subSectionReferId, true);
    onUpdateBookmarkProgress(bookmarkProgress);
    onUpdateIsAutoPlayVideo(true);
    setOpen(false);
  };

  const handleOnCancel = () => {
    onUpdateIsAutoPlayVideo(true);
    setOpen(false);
  };

  return (
    <Fragment>
      {React.cloneElement(<ResumeClassroomDialogComponent />, {
        open: open,
        onResume: handleOnResume,
        onCancel: handleOnCancel,
      })}
    </Fragment>
  );
};

const ResumeClassroomDialog = ({
  course,
  bookmarkProgress,
  onUpdateCurrentSubsection,
  onUpdateBookmarkProgress,
  onUpdateIsAutoPlayVideo,
}) => {
  return (
    <ResumeClassroom
      bookmarkProgress={bookmarkProgress}
      onUpdateCurrentSubsection={onUpdateCurrentSubsection}
      onUpdateBookmarkProgress={onUpdateBookmarkProgress}
      onUpdateIsAutoPlayVideo={onUpdateIsAutoPlayVideo}
      resumeClassroomDialogComponent={({ open, onResume, onCancel }) => (
        <ResumeClassroomDialogView
          open={open}
          course={course}
          bookmarkProgress={bookmarkProgress}
          onConfirm={onResume}
          onCancel={onCancel}
        />
      )}
    />
  );
};

ResumeClassroomDialog.propTypes = {
  course: PropTypes.object,
  bookmarkProgress: PropTypes.object,
  onUpdateCurrentSubsection: PropTypes.func,
  onUpdateBookmarkProgress: PropTypes.func,
  onUpdateIsAutoPlayVideo: PropTypes.func,
};

ResumeClassroomDialog.defaultProps = {
  course: {},
  bookmarkProgress: {},
  onUpdateCurrentSubsection: () => {},
  onUpdateBookmarkProgress: () => {},
  onUpdateIsAutoPlayVideo: () => {},
};

export default ResumeClassroomDialog;
